import React from 'react';
import PropTypes from 'prop-types';
import styles from '../css/app.css';

const Logo = ({
  logoSrc,
  accountName,
}) => (
  <div className={styles.logo_wrapper}>
    <object data={logoSrc} style={{ height: '100%', width: '100%', borderRadius: '50%' }}>
      <img
        className={styles.logo}
        src="https://buffer.com/images/shopGrid/emptyAvatar.jpg"
        alt={accountName}
      />
    </object>
  </div>
);

Logo.propTypes = {
  logoSrc: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
};

export default Logo;



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/components/Logo.jsx
 **/